(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq-category"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
    const details = document.querySelectorAll(".category-container");
    console.log(details);

    details.forEach(detail => {
      console.log('visibilityDesktop' in detail.dataset);

      if (window.innerWidth > 768 && detail.dataset.visibilityDesktop === "true") {
        detail.setAttribute("open", "true"); 
      } else if (window.innerWidth < 768 && detail.dataset.visibilityMobile === "true"){
        detail.setAttribute("open", "true"); 
      }else {
        detail.removeAttribute("open"); 
      }
    });
    
  });
  } catch(e) { console.error(e); }
})();

})();
